import { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, DocumentIcon } from '@heroicons/react/24/outline';
import Loading from 'src/components/Loading';
import EyeIcon from 'src/components/ui-icons/reports/EyeIcon';
import { DownloadIcon } from 'src/components/ui-icons/upload';
import { isPreviewable } from 'src/hooks/useFilePreview';
import { FlexCol, FlexRow } from 'src/utils/flexLayouts';
import { useFilePreview5SMobile } from './useFilePreview5S.mobile';

export interface PrevFile {
  name: string;
  sizeBytes: number;
  url?: string;
  fileId?: number;
}

export interface PrevInc {
  id: number;
  documentId: string;
  Description: string;
  files: PrevFile[];
}

interface Props {
  answer?: string;
  inconsistencies: PrevInc[];
}

const PrevAuditInfoMobile = ({ answer, inconsistencies }: Props) => {
  const [open, setOpen] = useState(false);
  const { openPreview, previewLoadingId, downloadFile, downloadingUrl, PreviewModal } = useFilePreview5SMobile();

  const hasIncs = inconsistencies.length > 0;

  if (!answer && !hasIncs) return null;

  return (
    <FlexCol className='w-full bg-[#F4F6F8] rounded-lg px-4 py-3 mt-2 gap-2'>
      <FlexRow
        className={`items-center justify-between ${hasIncs ? 'cursor-pointer' : ''}`}
        onClick={() => hasIncs && setOpen((s) => !s)}
      >
        <span className='text-sm text-[#637381]'>
          Ответ последнего аудита: {answer || '—'}
        </span>
        {hasIncs && (open ? (
          <ChevronUpIcon className='w-5 h-5 text-[#637381] shrink-0' />
        ) : (
          <ChevronDownIcon className='w-5 h-5 text-[#637381] shrink-0' />
        ))}
      </FlexRow>

      {open && hasIncs && (
        <FlexCol className='gap-2'>
          {inconsistencies.map((inc, incIdx) => (
            <FlexCol key={inc.documentId} className='gap-2'>
              <span className='text-sm text-[#637381]'>
                Несоответствие{inconsistencies.length > 1 ? ` ${incIdx + 1}` : ''}: {inc.Description}
              </span>
              {inc.files.map((file, idx) => (
                <FlexRow key={idx} className='items-center justify-between p-3 bg-white rounded-lg'>
                  <FlexRow className='items-center flex-1 min-w-0 mr-4'>
                    <DocumentIcon className='w-5 h-5 text-slate-400 mr-3 shrink-0' />
                    <span className='truncate text-sm text-[#1F2A37]'>{file.name}</span>
                  </FlexRow>
                  <FlexRow className='items-center gap-3 shrink-0'>
                    {isPreviewable(file.url) && (
                      <button
                        type='button'
                        onClick={() => openPreview(file.url, file.fileId)}
                        className='p-1'
                        title='Предпросмотр'
                      >
                        {previewLoadingId === file.fileId ? (
                          <FlexCol className='w-6 h-6'>
                            <Loading />
                          </FlexCol>
                        ) : (
                          <EyeIcon />
                        )}
                      </button>
                    )}
                    {file.url && (
                      <button
                        type='button'
                        onClick={() => downloadFile(file.url, file.name)}
                        className='p-1'
                        title='Скачать'
                      >
                        {downloadingUrl === file.url ? (
                          <FlexCol className='w-6 h-6'>
                            <Loading />
                          </FlexCol>
                        ) : (
                          <DownloadIcon />
                        )}
                      </button>
                    )}
                  </FlexRow>
                </FlexRow>
              ))}
            </FlexCol>
          ))}
        </FlexCol>
      )}

      {PreviewModal}
    </FlexCol>
  );
};

export default PrevAuditInfoMobile;
